import $ from "jquery";
import React from "react";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import translations from "translations.json"; // eslint-disable-line

export default function renderComponent(Component, el) {
  const $el = $(el);
  const props = $el.data("props");

  if (!$el.length) {
    return false;
  }

  const extendedLocale = props.locale;

  let localeMemo = "";
  const messages = {};

  // merge on each level of the locale segments for fallbacks
  // en = {one: '...'}
  // en-us = {one: '...', two: '...'}
  // en-us-real_estate = {three: '...'}
  // en-us-real_estate-realtor = {one: '...', four: '...'}
  // messages = {one:, two:, three:, four:}
  extendedLocale.split("-").forEach(localeSegment => {
    if (localeMemo) {
      localeMemo = [localeMemo, localeSegment].join("-");
    } else {
      localeMemo = localeSegment;
    }
    Object.assign(messages, translations[localeMemo] || {});
  });

  const container = $el.get(0);
  const root = createRoot(container);

  root.render(
    <IntlProvider locale={navigator.language || "en"} messages={messages}>
      <Component {...props} />
    </IntlProvider>
  );

  return root;
}
